import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "as"];
/** This component has been marked as a server component in /scripts/use-client..mjs **/
import React from 'react';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { ecx } from "../../utils.mjs";
/**
 * HorizontalRule is a thin line that is inserted into flow content to denote a break in the content, without introducing a new section as a heading would.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-horizontalrule--docs) |
 * [Encore site](https://encore.spotify.net/web/components/horizontal-rule) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/HorizontalRule) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=3755-6810&t=SlcSOGwMfUq5fUJD-1)
 */
export var HorizontalRule = function HorizontalRule(_ref) {
  var className = _ref.className,
    as = _ref.as,
    props = _objectWithoutProperties(_ref, _excluded);
  var Element = as || 'hr';
  return /*#__PURE__*/React.createElement(Element, Object.assign({
    className: ecx(['horizontal-rule', 'baseline'], className),
    "data-encore-id": ENCORE_DATA_IDS.HorizontalRule
  }, props));
};